<p-divider align="left" >
  <b style="background-color: var(--surface-ground);">Workflow stages</b>
</p-divider>
<div class="text-500 mb-3 font-medium text-sm">
  View and edit items in your assigned workflow stages. Complete required attributes to move items to the next stage.
</div>
<div class="grid">
  <div class="col-12 lg:col-4 xl:col-3" *ngFor="let stage of myStages">
    <div class="card mb-0 editor-card" style="cursor: pointer;"
      [style.--stage-shadow]="getStageShadow(stage.color)" (click)="navigateToStage(stage)">
      <div class="flex justify-content-between mb-3">
        <div class="flex align-items-center justify-content-center border-round" [style.background-color]="stage.color"
          [ngStyle]="{width: '2.5rem', height: '2.5rem',opacity:'0.5'}">
            <i *ngIf="stage.autoStageTemplate" class="pi pi-cog pi-spin"  style="font-size: 1.5rem;"></i>
        </div>
        <div>
          <p-badge *ngIf="!loadingCount" [value]="itemCounts[stage.id]" severity="info"></p-badge>
          <i *ngIf="loadingCount" class="pi pi-spin pi-spinner"></i>
          <span class="block text-500 font-medium mb-3"></span>
          <!-- <div class="text-900 font-medium text-xl">{{itemCounts[stage.id]}}</div> -->
        </div>

      </div>
      <div style="white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;"> {{stage.stageName}}</div>
    </div>
  </div>
  <div class="col-12 lg:col-4 xl:col-3" *ngIf="hasWorkflowPermission">
    <div class="card mb-0" style="cursor: pointer; border: 4px dashed var(--surface-border);" (click)="gotoWorkflowSettings()">
      <div class="flex flex-column align-items-center justify-content-center mb-3">
        <i class="pi pi-plus-circle" style="font-size: 1.5rem; color: var(--primary-color); margin-bottom: 0.5rem;"></i>
        <div style="color: var(--primary-color); font-weight: 500;">Add New Stage</div>
      </div>
    </div>
  </div>
</div>
